module.exports = __webpack_public_path__ + "img/insta.17eb3b2a.svg";